import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import { styleSelect } from '../../../../rbts/assets/ts/_utils';
import { ShiftSupplierGrid } from './ShiftSupplierGrid';
import {
  useExecuteStarShiftSuplier,
  useSelectSuppliersClosed,
} from '../hooks/StartShiftHook';
import { SimpleAlert } from '../../../../rbts/helpers';
import {
  useGetAllDaysSelect,
  useSelectSuppliers,
} from '../../sales/Suppliers/hooks/SalesSupplierHook';
import { MensajeDia } from '../../../../rbts/helpers/components/MensajeDia';
import { ModalCE } from '../_modals/ModalCE';
import { RemoveModal } from '../_modals/RemoveModal';
import { ListadoPuntosVenta } from './ListadoPuntosVenta';
import {
  eliminarPuntoVentaService,
  eliminarPVDiaVentaService,
} from '../../../service/start_shift/StartShift';

type Props = {};

const View: React.FC<Props> = ({}) => {
  const [reloadTipo, setReloadTipo] = useState<number>(Math.random() * 40);
  const { suppliers, loadingRequest } = useSelectSuppliers(
    false,
    reloadTipo,
    false
  );
  const { catalog: day } = useGetAllDaysSelect();
  const [strDate, setStrDate] = useState<string>('');
  const [currentDay, setCurrentDay] = useState<number>(0);
  const [register, setRegister] = useState<number>(0);

  const { loadingRequest: loadingStartShift, startDay } =
    useExecuteStarShiftSuplier();
  const [supplierSelected, setSupplierSelected] = useState<any | null>([]);
  const [reloadInfo, setReloadInfo] = useState<number>(Math.random() * 40);
  const [showNoteModal, setShowNoteModal] = useState<boolean>(false);

  const [isDisabled, setIsDisabled] = useState<boolean>(true);
  const [showRemoveModal, setShowRemoveModal] = useState<boolean>(false);
  const [removeModalTitulo, setRemoveModalTitulo] = useState<string>('');
  const [removeModalMensaje, setRemoveModalMensaje] = useState<string>('');
  const confirmCallbackRef = useRef<() => Promise<void>>(async () => {});

  const handleSupplierOnChange = (selectedOption: any) => {
    if (selectedOption) {
      setSupplierSelected(selectedOption);
      setIsDisabled(false);
    } else {
      setSupplierSelected(null);
      setIsDisabled(true);
    }
  };
  const openModal = (isOpen: boolean) => {
    setShowNoteModal(isOpen);
  };

  const openRemovePV = (id: number) => {
    confirmCallbackRef.current = () => eliminarPuntoVentaService(id);
    setRemoveModalTitulo('Eliminar punto de venta');
    setRemoveModalMensaje(
      '¿Está seguro de que desea eliminar este punto de venta? Se eliminará permanentemente del catálogo.'
    );
    setShowRemoveModal(true);
  };

  const openRemovePVDV = (id: number) => {
    confirmCallbackRef.current = () => eliminarPVDiaVentaService(id);
    setRemoveModalTitulo('Eliminar punto de venta del día');
    setRemoveModalMensaje(
      '¿Está seguro de que desea eliminar este punto de venta del día actual? Se eliminará su registro de turno para hoy.'
    );
    setShowRemoveModal(true);
  };

  useEffect(() => {
    if (day) {
      const {
        dia: { id },
        fecha_str,
      } = day;
      setStrDate(fecha_str);
      setCurrentDay(id);
    } else {
    }
  }, [day]);

  return (
    <>
      {currentDay === 0 ? (
        // <MensajeDia mensaje={''} />
        <div className="card mb-6 mb-xl-9">
          <div className="card-header border-0">
            <h3 className="card-title"></h3>
            <div className="text-end">
              <button
                type="button"
                title="Nueva venta"
                onClick={() => {
                  openModal(true);
                }}
                className={`btn btn-primary mt-5`}
              >
                <span className="indicator-label">Nuevo punto de venta</span>
              </button>
            </div>
          </div>
          <div className="card-body">
            <ListadoPuntosVenta
              reloadGrid={reloadInfo}
              editRegister={(id) => {
                if (id > 0) {
                  setRegister(id);
                  openModal(true);
                }
              }}
              removeRegister={(id) => {
                if (id > 0) openRemovePV(id);
              }}
            ></ListadoPuntosVenta>
          </div>
        </div>
      ) : (
        <>
          <div className="card mb-6 mb-xl-9">
            <div className="card-header border-0">
              <h3 className="card-title">
                <span className="card-label fw-bold text-gray-800">
                  Fecha administrativa:
                </span>
                <span className="fs-4 text-gray-700">{strDate}</span>
              </h3>
              <div className="text-end">
                <button
                  type="button"
                  title="Nueva venta"
                  onClick={() => {
                    openModal(true);
                  }}
                  className={`btn btn-primary mt-5`}
                >
                  <span className="indicator-label">Nuevo punto de venta</span>
                </button>
              </div>
            </div>
            <div className="card-body">
              <ShiftSupplierGrid
                reloadGrid={reloadInfo}
                editRegister={(id) => {
                  if (id > 0) {
                    setRegister(id);
                    openModal(true);
                  }
                }}
                removeRegister={(id) => {
                  if (id > 0) openRemovePVDV(id);
                }}
              ></ShiftSupplierGrid>
            </div>
          </div>
        </>
      )}
      <ModalCE
        show={showNoteModal}
        handleClose={(refresh) => {
          setShowNoteModal(!showNoteModal);
          setRegister(0);
          if (refresh) {
            setReloadInfo(Math.random() * 40);
            setReloadTipo(Math.random() * 40);
          }
        }}
        id={register}
      ></ModalCE>
      <RemoveModal
        show={showRemoveModal}
        titulo={removeModalTitulo}
        mensaje={removeModalMensaje}
        onConfirm={() => confirmCallbackRef.current()}
        handleClose={(updated) => {
          setShowRemoveModal(false);
          if (updated) setReloadInfo(Math.random() * 40);
        }}
      ></RemoveModal>
    </>
  );
};

export { View };
